import axios from 'axios'
import { API_BASE_URL, API_TIMEOUT_MS, IS_DEV } from '../constants/api.js'
import { authStorage } from '../utils/authStorage.js'

const SENSITIVE_KEYS = new Set([
  'password',
  'token',
  'accessToken',
  'refreshToken',
  'otp',
  'authorization',
  'Authorization',
  'razorpay_signature',
  'keySecret',
  'key_secret',
])

const sanitize = (value) => {
  if (!value || typeof value !== 'object') return value

  if (Array.isArray(value)) {
    return value.map(sanitize)
  }

  return Object.fromEntries(
    Object.entries(value).map(([key, nestedValue]) => [
      key,
      SENSITIVE_KEYS.has(key) ? '[REDACTED]' : sanitize(nestedValue),
    ])
  )
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: API_TIMEOUT_MS,
  withCredentials: true,
})

api.interceptors.request.use(
  (config) => {
    const token = authStorage.getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    if (IS_DEV) {
      const method = (config.method || 'GET').toUpperCase()
      const path = `${config.baseURL || ''}${config.url || ''}`
      const payload = config.data ? sanitize(config.data) : undefined
      if (payload) {
        console.debug(`[API] ${method} ${path}`, payload)
      }
    }

    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (IS_DEV && error.config?.url) {
      console.warn(
        `[API ERROR] ${(error.config.method || 'GET').toUpperCase()} ${error.config.url}`,
        error.response?.status || error.message
      )
    }

    if (error.response?.status === 401) {
      authStorage.clearAll()
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.assign('/login')
      }
    }

    return Promise.reject(error)
  }
)

export default api
